import { Model } from "survey-react"
import styles from "./styles.module.scss"
import classNames from "classnames"
import { IPlainDataOptions } from "packages/survey-core/src/base-interfaces"
import { Collapse, CollapseProps } from "antd"
import Choice from "./choice"

interface IProps {
  formDefinition: any
  formAnswers: any
  plainDataOptions?: IPlainDataOptions
}

function DiagnosticResult({
  formDefinition,
  formAnswers,
  plainDataOptions = {},
}: IProps) {
  const survey = new Model(formDefinition)

  survey.data = formAnswers

  const items: CollapseProps["items"] = survey
    .getPlainData({
      includeQuestionTypes: true,
      includeValues: true,
      ...plainDataOptions,
    })
    .filter((question) => !String(question.name).endsWith("-Comment"))
    .map((question) => ({
      key: question.name,
      label: (
        <div className={styles.collapseHeader}>
          <div
            className={classNames(
              "body-heavy",
              styles.textContainer,
              styles.label
            )}
          >
            {question.title}
          </div>
          <div
            className={classNames(
              styles.textContainer,
              ["checkbox", "radiogroup", "paneldynamic"].includes(
                question.questionType!
              ) && styles.checkboxTypeText
            )}
          >
            {typeof question.displayValue === "string"
              ? question.displayValue
              : JSON.stringify(question.displayValue, null, 2)}
          </div>
        </div>
      ),
      collapsible: ["checkbox", "radiogroup", "paneldynamic"].includes(
        question.questionType!
      )
        ? "header"
        : "disabled",
      showArrow: ["checkbox", "radiogroup", "paneldynamic"].includes(
        question.questionType!
      ),
      children: question.data?.map((choice) => (
        <Choice
          key={choice.name}
          choice={choice}
          questionType={question.questionType}
        />
      )),
    }))

  return (
    <div className={styles.diagnostic}>
      <Collapse items={items} />
    </div>
  )
}

export default DiagnosticResult
